import { combineReducers } from "redux"
import { productionLines } from "./productionLinesReducer"

const productionLinesReducer = combineReducers({
    productionLines
})

export default productionLinesReducer
